<template>
  <div>
    <div class="map-filter">
      <label
        for="title"
        class="map-filter-title"
      >
        Suchen nach Titel
      </label>
      <input
        id="title"
        v-model="title"
        class="map-filter-input"
        type="text"
        placeholder="Titel"
      >

      <span class="map-filter-title">Suchen nach Schrift</span>
      <div class="map-filter-scripts">
        <div class="map-filter-button map-filter-script"
             v-for="script in scripts"
             :class="{ active: (currentAlphabet || '').split(',').includes(script.value) }"
             :key="script.value"
             @click="toggleActiveAlphabet(script)"
             @mouseover="mouseover(script)"
             @mouseleave="mouseleave(script)"
             :title="script.text"
        >
          <img
            v-if="((currentAlphabet || '').split(',').includes(script.value) || script.hover) && script.code"
            :src="require('../../../assets/images/script/' + script.code + '-w.svg')"
            :alt="script.name"
          />
          <img
            v-else-if="script.code"
            :src="require('../../../assets/images/script/' + script.code + '.svg')"
            :alt="script.name"
          />
          <span class="map-filter-language" v-else>
            . . .
          </span>
        </div>
      </div>

      <span class="map-filter-title">Suchen nach Sprache</span>
      <div class="map-filter-scripts">
        <div class="map-filter-button map-filter-script"
             v-for="(language, i) in languages"
             v-if="(currentLanguage || '').split(',').includes(language.value) || !languagesClosed || i < 12"
             :class="{ active: (currentLanguage || '').split(',').includes(language.value) }"
             :key="language.value"
             @click="toggleActiveLanguage(language)"
        >
        <span :title="language.name" class="map-filter-language">
          {{ language.code }}
        </span>
        </div>
      </div>
      <div class="more" @click="languagesClosed =! languagesClosed">
        <span v-if="languagesClosed">
          <a>
            mehr
          </a>
        </span>
        <span v-else>
          <a>
            weniger
          </a>
        </span>
      </div>

      <span class="map-filter-title">Suchen mit ODER?</span>
      <div class="map-filter-toggle">
        <div class="map-filter-toggle-button" :class="{ 'active': orSearch }" @click="toggleOrSearch()">
          Ja
        </div>
        <div class="map-filter-toggle-button" :class="{ 'active': !orSearch }" @click="toggleOrSearch()">
          Nein
        </div>
      </div>


      <p class="map-filter-text">
        Die Suchfunktion ist so eingestellt, dass nur Fotos mit ALLEN ausgewählten Sprachen und Schriften angezeigt
        werden. Wähle unten die Option "Suchen mit ODER?" um die Suchanfrage entsprechend zu öffnen. Die Sprachen auf
        einem Foto werden dann durch die Farbe der Stecknadeln auf der Karte markiert.
      </p>
    </div>

    <div class="map-filter-search" v-if="false">
      <div class="map-filter-search-button primary">
        Suchen
      </div>
      <div class="map-filter-search-button">
        Weitere Suchoptionen
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'Facets',
    data () {
        return {
            scripts: [
                { text: 'Lateinisch', value: 'AL001', code: 'latin', hover: false },
                { text: 'Arabisch', value: 'AL002', code: 'arabic', hover: false },
                { text: 'Armenisch', value: 'AL041', code: 'armenian', hover: false },
                { text: 'Chinesisch', value: 'AL003', code: 'chinese', hover: false },
                { text: 'Georgisch', value: 'AL017', code: 'georgian', hover: false },
                { text: 'Griechisch', value: 'AL009', code: 'greek', hover: false },
                { text: 'Hebräisch', value: 'AL007', code: 'hebrew', hover: false },
                { text: 'Indische Schrift', value: 'AL005', code: 'indian', hover: false },
                { text: 'Japanisch', value: 'AL014', code: 'japanese', hover: false },
                { text: 'Koreanisch', value: 'AL012', code: 'korean', hover: false },
                { text: 'Thailändisch', value: 'AL015', code: 'thai', hover: false },
                { text: 'Sonstige', value: 'ALOTHER', hover: false },
            ],
            languages: [
                { name: 'Deutsch', value: 'LA056', code: 'de' },

                { name: 'Arabisch', value: 'LA003', code: 'ar' },
                { name: 'Chinesisch', value: 'LA004', code: 'zh' },
                { name: 'Englisch', value: 'LA001', code: 'en' },
                { name: 'Französisch', value: 'LA008', code: 'fr' },
                { name: 'Italienisch', value: 'LA013', code: 'it' },
                { name: 'Polnisch', value: 'LA024', code: 'pl' },
                { name: 'Portugiesisch', value: 'LA048', code: 'pt' },
                { name: 'Russisch', value: 'LA027', code: 'ru' },
                { name: 'Spanisch', value: 'LA029', code: 'es' },
                { name: 'Türkisch', value: 'LA034', code: 'tr' },
                { name: 'Vietnamesisch', value: 'LA033', code: 'vi' },

                { name: 'Akan', value: 'LA057', code: 'ak' },
                { name: 'Albanisch', value: 'LA058', code: 'sq' },
                { name: 'Armenisch', value: 'LA041', code: 'hy' },
                { name: 'Bosnisch', value: 'LA059', code: 'bs' },
                { name: 'Dänisch', value: 'LA060', code: 'da' },
                { name: 'Filipino', value: 'LA055', code: 'fil' },
                { name: 'Friesisch', value: 'LA061', code: 'fy' },
                { name: 'Griechisch', value: 'LA010', code: 'el' },
                { name: 'Hebräisch', value: 'LA011', code: 'he' },
                { name: 'Hindi', value: 'LA012', code: 'hi' },
                { name: 'Indonesisch', value: 'LA062', code: 'id' },
                { name: 'Japanisch', value: 'LA014', code: 'ja' },
                { name: 'Jiddisch', value: 'LA035', code: 'yi' },
                { name: 'Koreanisch', value: 'LA015', code: 'ko' },
                { name: 'Kroatisch', value: 'LA007', code: 'hr' },
                { name: 'Kurdisch (Kurmanji)', value: 'LA016', code: 'kmr' },
                { name: 'Kurdisch (Sorani)', value: 'LA017', code: 'ckb' },
                { name: 'Lettisch', value: 'LA018', code: 'lv' },
                { name: 'Litauisch', value: 'LA019', code: 'lt' },
                { name: 'Malaiisch', value: 'LA020', code: 'ms' },
                { name: 'Mazedonisch', value: 'LA063', code: 'mk' },
                { name: 'Niederdeutsch', value: 'LA064', code: 'nds' },
                { name: 'Niederländisch', value: 'LA044', code: 'nl' },
                { name: 'Paschtunisch', value: 'LA022', code: 'ps' },
                { name: 'Persisch', value: 'LA023', code: 'fa' },
                { name: 'Punjabi', value: 'LA025', code: 'pa' },
                { name: 'Rumänisch', value: 'LA026', code: 'ro' },
                { name: 'Serbisch', value: 'LA049', code: 'sr' },
                { name: 'Slowakisch', value: 'LA051', code: 'sk' },
                { name: 'Slowenisch', value: 'LA052', code: 'sl' },
                { name: 'Somali', value: 'LA028', code: 'so' },
                { name: 'Swahili', value: 'LA053', code: 'sw' },
                { name: 'Thai', value: 'LA054', code: 'th' },
                { name: 'Tschechisch', value: 'LA043', code: 'cs' },
                { name: 'Ukrainisch', value: 'LA032', code: 'uk' },
                { name: 'Ungarisch', value: 'LA045', code: 'hu' },
                { name: 'Urdu', value: 'LA047', code: 'ur' },
                { name: 'Wolof', value: 'LA066', code: 'wo' },
                { name: 'Yoruba', value: 'LA067', code: 'yo' },
                { name: 'Sonstige', value: 'LAOTHER', code: '. . .' },
            ],
            scriptClosed: true,
            languagesClosed: true,
        };
    },
    computed: {
        ...mapState('facets', {
            currentLanguage: 'language',
            currentAlphabet: 'alphabet',
        }),
        title: {
            get () {
                return this.$store.state.facets.title;
            },
            set (value) {
                this.setTitle(value);
            }
        },
        orSearch: {
            get () {
                return this.$store.state.facets.orFlag;
            },
            set (value) {
                this.setOrFlag(value);
            }
        }
    },
    methods: {
        ...mapActions('facets', [
            'updateMarkers',
            'setTitle',
            'setOrFlag',
            'setLanguage',
            'setAlphabet',
        ]),
        toggleActiveAlphabet (facet) {
            const values = (this.currentAlphabet || '').split(',');

            if (values.includes(facet.value)) {
                values.splice(values.indexOf(facet.value), 1)
            } else {
                values.push(facet.value);
            }

            this.setAlphabet(values);
        },
        toggleActiveLanguage (facet) {
            const values = (this.currentLanguage || '').split(',');

            if (values.includes(facet.value)) {
                values.splice(values.indexOf(facet.value), 1)
            } else {
                values.push(facet.value);
            }

            this.setLanguage(values);
        },
        toggleOrSearch () {
            this.orSearch = !this.orSearch;
        },
        mouseover (script) {
            script.hover = true;
        },
        mouseleave (script) {
            script.hover = false;
        },
    },
};
</script>

<style>
.map-filter {
  width: 255px;
  margin-right: 20px;
  padding: 0 26px 30px;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
}

.map-filter-button img {
  width: 100%;
}

@media (max-width: 800px) {
  .map-filter {
    width: auto;
    margin-right: 0;
  }
}

.map-filter-title {
  font-size: 19px;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 30px;
  font-weight: bold;
  font-family: TheSansUHH-Caps, sans-serif;
}

.map-filter-input {
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  font-size: 19px;
  line-height: 20px;
  height: 32px;
  padding: 3px 12px;
}

.map-filter-scripts {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.map-filter-script {
  width: 42px;
  height: 42px;
}

.map-filter-script:focus {

}

.map-filter-button {
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  margin: 4px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  user-select: none;
}

.map-filter-button:hover {
  border: 1px solid #ddd;
  background-color: rgba(2, 123, 203, 0.7);
  color: white;
}

.map-filter-button.active {
  border: 1px solid #ddd;
  box-shadow: none;
  background-color: #027bcb;
  color: white;
}

.map-filter-language {
  font-size: 16pt;
  display: flex;
  flex-direction: column;
  justify-content: center;
  user-select: none;
  width: 100%;
  text-align: center;
}

.map-filter-toggle {
  display: flex;
  flex-direction: row;
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  margin: 4px;
}

.map-filter-search-button {
  height: 45px;
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  margin: 10px 4px 4px 4px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  user-select: none;
}

.map-filter-toggle-button {
  width: 45px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  flex: 1 1 auto;
  overflow-y: auto;
  cursor: pointer;
  user-select: none;
}

.map-filter-toggle-button.active {
  background-color: #027bcb;
  color: white;
}

.map-filter-search {
  margin-top: auto;
  margin-right: 20px;
  padding: 15px;
}

.primary {
  background-color: #027bcb;
  color: white;
}

.map-filter-text {
  padding: 4px
}

.more {
  margin: 5px 10px 0;
  cursor: pointer;
}

.more :hover {
  text-decoration: underline;
}
</style>
